<form [formGroup]="selectRolesForm">
    <app-checkbox
        *ngFor="let role of roles"
        [formControlName]="role"
        [text]="getRoleText(role)"
        (ngModelChange)="roleChange(role, $event)"
    />
</form>
